import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { Box } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * A mark rather than a count.
 *
 * Counting here would mean running both derivations over every elevator in scope on
 * every page load, to fill a label most page views never look at. The counts that
 * matter are columns in each grid.
 */
export const serviceHistoryTabLabel = (): ReactNode => (
  <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
    Service History
    <AssignmentTurnedInIcon sx={{ fontSize: 18, color: 'primary.main' }} />
  </Box>
);
